import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { FaBell, FaClipboardList, FaCog, FaMoon } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { getMe } from '../api/loginAPI';
import {
  getNotificationsByUserId,
  clearNotificationById,
  clearAllNotificationsByUser,
} from '../api/notificationAPI';

function Header() {
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [user, setUser] = useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const fetchNotifications = async (userId) => {
    const data = await getNotificationsByUserId(userId);
    const sorted = [...data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    setNotifications(sorted);
  };

  useEffect(() => {
    async function init() {
      const userData = await getMe();
      setUser(userData);
      await fetchNotifications(userData.Id);
    }
    init();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const toggleDropdown = () => setDropdownOpen(prev => !prev);
  const toggleTheme = () => setDarkMode(prev => !prev);

  const unreadCount = notifications.length;

  const handleNotificationClick = async (n) => {
    await Swal.fire({
      title: n.notification_headline,
      text: n.notification_description,
      icon: 'info',
    });

    await clearNotificationById(n.notification_id);
    setNotifications(prev => prev.filter(item => item.notification_id !== n.notification_id));
  };

  const handleClearAll = async () => {
    if (!user?.Id) return;
    await clearAllNotificationsByUser(user.Id);
    setNotifications([]);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <header className="header">
      <div className="gradient-bar"></div>
      <div className="user-info">
        <div className="user-details">
          <span>{user?.name || 'UserName'}</span>
          <span className="role">{user?.role || 'ADMIN'}</span>
        </div>
        <div className="header-icons">
          <div className="notification-wrapper" ref={dropdownRef}>
            <FaBell className="icon" onClick={toggleDropdown} />
            {unreadCount > 0 && <span className="badge">{unreadCount}</span>}

            <div className={`notification-dropdown${isDropdownOpen ? ' open' : ''}`}>
              <div className="notif-header">
                <span>Notifications</span>
                <button onClick={handleClearAll}>Clear all</button>
              </div>
              <div className="notif-list">
                {notifications.length === 0 && <div className="empty">No notifications</div>}
                {notifications.map((n, index) => (
  <div
    key={n.notification_id || n.id || index}
    className="notification-item"
    onClick={() => handleNotificationClick(n)}
  >
    <div className="notif-title">{n.notification_headline}</div>
    <div className="notif-time">
      {new Date(n.created_at).toLocaleString()}
    </div>
  </div>
))}
              </div>
            </div>
          </div>

          <div className="tooltip-wrapper" onClick={toggleTheme}>
            <FaMoon className="icon" />
            <span className="tooltip-text">Toggle Theme</span>
          </div>
          <div className="tooltip-wrapper">
            <a href="https://developers.myearth.id" target="_blank" rel="noopener noreferrer">
              <FaClipboardList className="icon" />
            </a>
            <span className="tooltip-text">Documentation</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
